import { useNavigate } from 'react-router';
import { EntityContextMenu } from 'src/ccm/careflow/common';
import api from 'src/ccm/services/api';
import { useDialogStore } from 'src/stores/dialog';

export interface GoalGroupsContextMenuProps {
  item: any;
  onEdit?: () => void | Promise<void>;
  onDelete?: () => void | Promise<void>;
  onAction?: (action: 'edit' | 'delete') => void | Promise<void>;
}

export default function GoalGroupsContextMenu({
  item,
  onEdit,
  onDelete,
  onAction,
}: GoalGroupsContextMenuProps) {
  const navigate = useNavigate();
  const { confirmDialog } = useDialogStore();

  return (
    <EntityContextMenu
      entity={item}
      items={[
        {
          label: 'Edit',
          icon: 'eva:edit-fill',
          onPress: async () => {
            navigate(`edit/${item.uuid}`);
            await onEdit?.();
            await onAction?.('edit');
          },
        },
        {
          label: 'Delete',
          icon: 'eva:trash-2-outline',
          onPress: async () => {
            const confirmed = await confirmDialog({
              title: 'Delete',
              description: 'Are you sure you want to delete this item?',
            });

            if (confirmed) {
              await api.carePlan.deleteGoalGroup(item.uuid);
              await onDelete?.();
              await onAction?.('delete');
            }
          },
        },
      ]}
    />
  );
}
